const hamburgerBtn = document.querySelectorAll("[data-hamburger-btn]");
const sideNav = document.querySelector("[data-side-nav]");


hamburgerBtn.forEach((hamBtn) => {
  hamBtn.addEventListener("click", () => {
    sideNav.classList.toggle("nav--open")
  })
})